<template>
  <div class="offer-listing-item-container position-relative" :class="{'full-width': fullWidth}">
    <div class="overlay" :class="{ 'modal_mode': modalMode }"></div>

    <div v-if="discount" class="discount">
      <svg viewBox="0 0 64 43" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
          <linearGradient x1="100%" y1="50%" x2="0%" y2="50%" id="linearGradient">
            <stop stop-color="#F58D59" offset="0%"></stop>
            <stop stop-color="#FFB81C" offset="100%"></stop>
          </linearGradient>
        </defs>
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M29,32 C29,30.3440708 30.3398357,29 32,29 C33.6555441,29 35,30.3440708 35,32 C35,33.6601643 33.6555441,35 32,35 C30.3398357,35 29,33.6601643 29,32 Z M47,20 L17,20 L0,36 L0,43 L64,43 L64,36 L47,20 Z" fill="url(#linearGradient)"></path> <path d="M32,29 C33.6555441,29 35,30.3440708 35,32 C35,33.6601643 33.6555441,35 32,35 C30.3398357,35 29,33.6601643 29,32 C29,30.3440708 30.3398357,29 32,29 M32.4615385,26 C28.6865245,26 26,28.6890206 26,32.4615385 C26,35.3149102 28.6865245,38 32.4615385,38 C35.313833,38 38,35.3149102 38,32.4615385 C38,28.6890206 35.313833,26 32.4615385,26" id="Circle" fill="#404040"></path> <path d="M28,0.447368421 C28.30521,0.447368421 28.5526316,0.694790007 28.5526316,1 C28.5526316,6.34549031 29.11877,9.97970495 30.3702022,14.3660189 L30.8575991,16.0177132 C31.649007,15.9698232 32.4807349,16.0165209 33.2965358,16.1886621 C33.266208,15.4304207 33.2318819,14.6294029 33.1933463,13.7839906 L33.0412609,10.6090072 C33.0018842,9.6625104 32.9975853,8.72295496 33.0188535,7.14262157 L33.0610212,4.42049218 C33.0875232,2.33096837 33.0687976,2.22137566 32.9772306,1.04280681 C32.9535891,0.738513836 33.181102,0.472670373 33.485395,0.449028822 C33.789688,0.425387271 34.0555314,0.652900206 34.079173,0.957193185 L34.1271659,0.686264335 C34.1830058,1.72839404 34.1886203,2.86178321 34.1620114,4.7471893 L34.1174425,7.70605322 C34.1028038,9.12022654 34.1145058,9.97632003 34.1615525,10.9099065 L34.3180887,14.1851469 C34.3546462,15.0017826 34.3871975,15.7769836 34.415718,16.5130192 C35.840726,17.0453698 37.1283589,18.0341831 37.9477109,19.6604774 C38.0028816,19.7696893 38.0086891,19.8878164 37.9912667,20 L37.9912667,20 L36.8813178,20 C36.2837584,18.9079522 35.429496,18.1758031 34.4611383,17.7211062 C34.7577651,26.3248333 34.4313154,29.0818448 33.433356,30.3429348 C33.2439583,30.5822707 32.8964011,30.6227536 32.6570652,30.433356 C32.4177293,30.2439583 32.3772464,29.8964011 32.566644,29.6570652 L32.6354445,29.5639272 C33.3817959,28.4825191 33.6409392,25.6642957 33.3395697,17.3263631 C32.6331363,17.1469543 31.897872,17.0848287 31.1796727,17.1117268 L31.5053104,18.2196538 C32.6284389,22.2544429 32.8797047,25.4302616 32.1421296,30.0864627 C32.0943776,30.387914 31.8112924,30.5935779 31.5098411,30.5458259 C31.2083898,30.4980739 31.0027259,30.2149886 31.0504779,29.9135373 C31.733398,25.6023648 31.5406868,22.6489215 30.566382,18.9787074 L30.3111003,18.0641981 C30.2405324,17.8214911 30.1545689,17.5292541 30.0648536,17.2258922 L29.9527924,17.2438212 L29.9527924,17.2438212 L29.7316203,17.286048 C28.4793888,17.5408757 27.2837799,18.4977797 26.2870762,20 L26.2870762,20 L25,20 C26.2217424,17.8915424 27.8086282,16.5423672 29.5189224,16.1931865 C29.5935812,16.1779247 29.6690175,16.1634747 29.7451699,16.14987 C29.5820491,15.6031323 29.4595292,15.1951266 29.4697909,15.2300442 C28.0786044,10.4962618 27.4473684,6.68257191 27.4473684,1 C27.4473684,0.694790007 27.69479,0.447368421 28,0.447368421 Z" id="Twine" fill="#6A6A6A"></path></g></svg>
      <div class="d-flex flex-column"><p>{{ $dictionary.offer_listing_item_discount_label }}</p><p class="value">{{ discount }}</p></div>
    </div>

    <div class="special-offer-box__image">
      <img :src="image ? image : $theme.media.placeholderOffer"/>
    </div>

    <listing-item-brand v-if="brandImage" :image="brandImage" :position="brandPosition"></listing-item-brand>

    <div class="special-offer-box__footer">
      <h3 v-if="!disableTitle">{{ title }}</h3>
      <span class="offer-category" v-if="!modalMode">Szczegóły oferty</span>
      <listing-item-labels v-if="offerTime" :labels="[offerTime]" :mode="'dark'"></listing-item-labels>
    </div>
  </div>
</template>

<script>
import ListingItemLabels from "./ListingItemLabels";
import ListingItemBrand from "./ListingItemBrand";

export default {
  name: "OfferListingItem",
  components: {ListingItemBrand, ListingItemLabels},
  props: {
    title: String,
    disableTitle: {
      type: Boolean,
      default: false,
    },
    modalMode: {
      type: Boolean,
      default: false
    },
    image: String,
    brandImage: String,
    offerTime: {
      type: String,
      default: null
    },
    category: {
      type: String,
      default: null
    },
    brandPosition: {
      type: String,
      default: 'top'
    },
    discount: String,
    fullWidth: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.discount {
  position: absolute;
  top: -1px;
  right: 1.25rem;
  width: 72px;
  transform: rotate(10deg);
  z-index: 1;
  transform-origin: top center;

  svg {
    width: 100%;
  }

  svg + div {
    margin-top: -1px;
    background: linear-gradient(to left, #F58D59, #FFB81C);
    text-align: center;
    padding: 0.75rem 0 1rem;

    p {
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
      letter-spacing: 0.2px;
      margin-bottom: 0;

      &.value {
        font-size: 20px;
        font-weight: 700;
        line-height: 28px;
      }
    }
  }
}

.special-offer-box {
  &__image {
    display: block;

    width: 100%;
    height: 100%;

    position: absolute;
    top: 0;
    left: 0;
  }

    &__footer {
      position: absolute;
      width: 100%;
      padding: 0;
      bottom: 0;
      z-index: 60;

      h3 {
        padding: 1rem 15px 2px 15px;
        margin-bottom: 0;
      }

      .listing-item-labels-container {
        top: 0;
        padding: 0 20px;
        text-align: left;
      }

      .offer-category {
        padding: 0 15px;
        font-size: 0.8rem;
      }
    }
  }

  .offer-listing-item-container .overlay {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    z-index: 50;
     background: linear-gradient(180deg, rgba(17, 17, 19, 0) 0%, rgba(17, 17, 19, 0.8) 100%);
  }

  .offer-listing-item-container {
    max-width: 368px;
    padding-bottom: 75%;

    cursor: pointer;
    position: relative;
    margin-bottom: 16px;

    &.full-width {
      max-width: 100%;
      cursor: default;
    }

    @media only screen and (max-width: 768px) {
      max-width: 100%;
    }

    .listing-item-brand-container {
      z-index: 60;
    }

    img {
      width: 100%;
      max-width: 100%;

      height: 100%;
      max-height: 100%;
    }

    @extend %offer-listing-item-container;
  }
</style>
